<template>
  <div class="welcome-page">
    <div v-if="isAdmin" class="welcome-page-error">
      <Strong>Administrator View</Strong>
      <p>To continue please select customer Test Edit</p>
    </div>
    <div class="welcome-page__title">
      <img src="~@/assets/logo.svg" class="logo" />
      <h3 class="welcome-page__title-text">
        {{ $t("page.start.title.welcome_message", [user.firstName]) }}
      </h3>
    </div>
    <div class="welcome-page__content">
      <div class="welcome-page__item">
        <div class="welcome-page__item-img">
          <img src="~@/assets/welcome-page-img1.svg" />
        </div>
        <div class="welcome-page__item-text">
          <span class="welcome-page__item-number">1</span>
          <div class="welcome-page__item-title">
            {{ $t("page.start.tutorial.first.title") }}
          </div>
          <div class="welcome-page__item-desc">
            {{ $t("page.start.tutorial.first.description") }}
          </div>
        </div>
      </div>
      <div class="welcome-page__item">
        <div class="welcome-page__item-img">
          <img src="~@/assets/welcome-page-img2.svg" />
        </div>
        <div class="welcome-page__item-text">
          <span class="welcome-page__item-number">2</span>
          <div class="welcome-page__item-title">
            {{ $t("page.start.tutorial.second.title") }}
          </div>
          <div class="welcome-page__item-desc">
            {{ $t("page.start.tutorial.second.description") }}
          </div>
        </div>
      </div>
      <div class="welcome-page__item">
        <div class="welcome-page__item-img">
          <img src="~@/assets/welcome-page-img3.svg" />
        </div>
        <div class="welcome-page__item-text">
          <span class="welcome-page__item-number">3</span>
          <div class="welcome-page__item-title">
            {{ $t("page.start.tutorial.third.title") }}
          </div>
          <div class="welcome-page__item-desc">
            {{ $t("page.start.tutorial.third.description") }}
          </div>
        </div>
      </div>
      <div class="welcome-page__item">
        <div class="welcome-page__item-img">
          <img src="~@/assets/welcome-page-img4.svg" />
        </div>
        <div class="welcome-page__item-text">
          <span class="welcome-page__item-number">4</span>
          <div class="welcome-page__item-title">
            {{ $t("page.start.tutorial.fourth.title") }}
          </div>
          <div class="welcome-page__item-desc">
            {{ $t("page.start.tutorial.fourth.description") }}
          </div>
        </div>
      </div>
    </div>
    <div class="v-button-center">
      <v-select
        v-if="isAdmin"
        class="select"
        v-model="chosenCustomer"
        :options="availableCustomers"
        title-property="name"
        value-property="clientId"
        placeholder="Choose Customer"
      />

      <v-button id="start-comtool-button" :disabled="isAdmin && !chosenCustomer" primary @click="startComTool()">
        {{ $t("page.start.button.text") }}
        <img src="~@/assets/icons/arrow-white.svg" />
      </v-button>
    </div>
  </div>
</template>

<script>
import { VButton, VSelect } from "shared";
import { mapActions, mapGetters } from "vuex";
import * as UserDAO from "@/dao/user-dao";

export default {
  name: "WelcomePage",
  components: {
    VSelect,
    VButton,
  },
  data() {
    return {
      chosenCustomer: null,
      availableCustomers: [],
    };
  },
  computed: {
    ...mapGetters({
      user: "user/userDetails",
    }),
    isAdmin() {
      return this.user.features.includes("comtool.customerselection");
    },
  },
  methods: {
    ...mapActions({
      getUserDetails: "user/getUserDetails",
    }),
    async startComTool() {
      if (this.isAdmin) {
        await UserDAO.setCustomer(this.chosenCustomer);
        await this.getUserDetails();
        this.redirect();
      } else {
        this.redirect();
      }
    },
    redirect() {
      this.$router.push({
        name: "chooseMedType",
      });
    },
  },
  async created() {
    if (this.isAdmin) {
      this.availableCustomers = await UserDAO.getUserCustomers();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables";
.welcome-page {
  padding: 120px 0;
  position: relative;
  &__title {
    text-align: center;
    &-text {
      font-size: 24px;
      line-height: 26px;
      text-align: center;
      letter-spacing: 0.8px;
      font-weight: normal;
      font-family: "fsalbertregular";
      margin: 17px 0;
      color: #333333;
    }
  }
  &__content {
    max-width: 1100px;
    margin: 80px auto 97px auto;
    display: flex;
    justify-content: space-between;
  }
  &__item {
    width: 20%;
    color: #333333;
    &-text {
      position: relative;
      padding: 0 0 0 38px;
    }
    &-img {
      text-align: center;
      min-height: 170px;
      margin-bottom: 30px;
    }
    &-title {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 17px;
      position: relative;
      margin-bottom: 9px;
    }
    &-desc {
      font-size: 13px;
      line-height: 16px;
      letter-spacing: 0.464286px;
    }
    &-number {
      position: absolute;
      font-size: 32px;
      line-height: 34px;
      letter-spacing: 1.31469px;
      left: 5px;
      top: 0;
    }
  }
  .select {
    width: 200px;
    margin: 1rem auto;
    text-align: left;
  }
  ::v-deep .options {
    width: 100%;
  }

  .button {
    padding: 12px 16px;
    text-align: left;
    width: 200px;
    img {
      float: right;
      margin: 0 0 0 auto;
    }
    &:disabled {
      background: transparent;
      pointer-events: none;
      border: 1px solid #ececec;
      img {
        filter: invert(1);
        opacity: 0.5;
      }
    }
  }
  &-error {
    width: 100%;
    background: red;
    color: #fff;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    text-align: center;
    padding: 20px 0;
    font-size: 20px;
    strong {
      text-transform: uppercase;
    }
  }
}
</style>
